import { AppClient } from "../../../../domain/generated/api";
import { Env } from "../../Env";

export const appClient: AppClient = new AppClient({ BASE: Env.apiBaseUrl });
